<template>
  <div class="top clearfix">
    <div class="btn_left">
      <p class="btn_font">请选择票种：</p>
      <invoice-type @success="initInvoiceNumber" :disabled='fs != "0"' v-model:code="temp.fplxdm"></invoice-type>
      
    </div>
    <div class="btn_right">
      <el-button v-if="temp.zsfs == '0'" type="primary" size="mini" @click="addRow" plain>新增</el-button>
      <el-button v-if="temp.zsfs == '0'" type="danger" size="mini" @click="delItem()" plain>删除</el-button>
      <el-button type="warning" @click="clear()" size="mini" style="margin-left:10px" plain>重填</el-button>
      <el-button v-if="temp.zsfs == '0'" type="primary" size="mini" @click="addZk()" plain>添加折扣</el-button>
      
      <el-button v-if="fpdm" type="success" @click="saveInvoice(0)" :loading="loading" size="mini" plain>开具</el-button>
      <el-button v-if="fpdm" type="success" @click="saveInvoice(4)" :loading="loading" size="mini" plain>保存模板</el-button>
      <qzf-import type="inventory" name="清单" @success="qdImportSuccess"></qzf-import>
      <el-switch style="margin-left:10px" :disabled="zkStatus" v-if="temp.zsfs == '0' || temp.zsfs == '2'" @change="changeHsbz()" v-model="hsbz" active-value="1" inactive-value="0" active-text="含税" inactive-text="不含税"></el-switch>
    </div>
  </div>
  <div class="big_box2">
    <p class="shuoming">*明细超过8行自动变为清单发票</p>
    <div class="name_box">
      <h2 v-if="temp.fplxdm == '004'">增值税专用发票</h2>
      <h2 v-if="temp.fplxdm == '007'">增值税普通发票</h2>
      <h2 v-if="temp.fplxdm == '025'">卷式发票</h2>
      <h2 v-if="temp.fplxdm == '026'">电子普通发票</h2>
      <clearfix2 v-if="temp.fplxdm == '005'">机动车发票</clearfix2>
      <h2 v-if="temp.fplxdm == '006'">二手车销售统一发票</h2>
      <h2 v-if="temp.fplxdm == '028'">增值税电子专用发票</h2>
    </div>
    <div class="home">
      <el-row :span="24">
        <el-col :xs="12" :sm="12" :lg="12">
          <el-select @change="zsfsChange" v-model="temp.zsfs" placeholder="请选择征税方式" size="mini">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-radio-group v-model="temp.tspz">
            <el-radio label="00">正常发票</el-radio>
            <el-radio :disabled="temp.zsfs != '0'" label="02">农产品收购</el-radio>
            <!-- <el-radio label="01">农产品销售</el-radio>
            <el-radio label="06">抵扣通行费</el-radio>
            <el-radio label="07">其它通行费</el-radio>
            <el-radio label="08">成品油销售</el-radio> -->
          </el-radio-group>
        </el-col>
  
        <!-- 负数冲红发票 -->
        <el-col :xs="12" :sm="12" :lg="12">
          <div style="float: right">
            <p v-if="fpdm">
              发票代码：{{fpdm}}  发票号码：{{fphm}}
            </p>
            <el-radio-group @change="changeFs()" v-model="fs" style="display:inline-block">
              <el-radio label="0">正常发票</el-radio>
              <el-radio v-if="temp.fplxdm != '004' && temp.fplxdm != '028'" label="1">负数发票</el-radio>
              <el-radio v-if="temp.fplxdm == '004' || temp.fplxdm == '028'" label="2">红冲发票</el-radio>
            </el-radio-group>
            <div style="display:inline-block;margin-left:15px">
              <redHand @success="redInfo" v-if="fs == '2'"></redHand>
              <!-- <el-button v-if="fs == '2'" type="primary" @click="handRed()" size="mini">手工开具</el-button> -->
              <redUpload @success="redInfo" v-if="fs == '2'"></redUpload>
              <!-- <el-button v-if="fs == '2'" type="primary" @click="handRedImport()" size="mini">导入红字信息表</el-button> -->
              <redHandFs @success="redInfo" v-if="fs == '1'"></redHandFs>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <el-row :span="24" class="row_box2">
        <el-col :xs="1" :sm="1" :lg="1">
          <div class="grid-content height_font">
              <p v-if="temp.tspz != '02'">购货单位</p>
              <p v-else>销货单位</p>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="12">
          <div>
            <el-form :label-position="labelPosition" label-width="100px" :model="temp" size="mini">
              <el-form-item label="名  称：">
                <span v-if="red">{{upCorp.ghdwmc}}</span>
                <corpghdw v-else v-model:name="upCorp.ghdwmc" @success="corpghdwSuccess"></corpghdw>
              </el-form-item>
              <el-form-item label="纳税人识别号：">
                <span v-if="red">{{upCorp.ghdwsbh}}</span>
                <el-input v-else v-model="upCorp.ghdwsbh"></el-input>
              </el-form-item>
              <el-form-item label="地址、电话：">
                <el-input v-model="upCorp.ghdwdzdh"></el-input>
              </el-form-item>
              <el-form-item label="开户行及账号：">
                <el-input v-model="upCorp.ghdwyhzh"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :xs="1" :sm="1" :lg="1">
          <div class="grid-content height_font">
          </div>
        </el-col>
        <el-col :xs="10" :sm="10" :lg="10">
          <el-form :label-position="labelPosition" label-width="100px" :model="temp" size="mini" >
              <el-form-item v-if="fs != '0'" label="原发票代码：">
                <el-input v-model="temp.yfpdm"></el-input>
              </el-form-item>
              <el-form-item v-if="fs != '0'" label="原发票号码：">
                <el-input v-model="temp.yfphm"></el-input>
              </el-form-item>
            <el-form-item label="手 机：">
              <el-input v-model="temp.name"></el-input>
            </el-form-item>
            <el-form-item label="邮 箱：">
              <el-input v-model="temp.region"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24">
          <el-table :data="items" border style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange" size="mini" :header-cell-style="{background:'#008000',color:'#ffff'}">
            <el-table-column type="selection" width="35" align="center"></el-table-column>
            <el-table-column type="index" min-width="50" label="序号" align="center"></el-table-column>
            <el-table-column label="货物或应税劳务名称" min-width="150" align="center">
              <template v-slot="scope">
                <span v-if="red">{{scope.row.spmc}}</span>
                <goods ref="goods" v-else :disabled="scope.row.fphxz != '0'" v-model:id="scope.row.itemId" v-model:name="scope.row.spmc" @success="goodSuccess($event, scope.row)"></goods>
              </template>
            </el-table-column>
            <el-table-column label="规格型号" min-width="120" align="center">
              <template v-slot="scope">
                <span v-if="red">{{scope.row.ggxh}}</span>
                <el-input v-else size="mini" :disabled="scope.row.fphxz != '0'" v-model="scope.row.ggxh"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单位" min-width="120" align="center">
              <template v-slot="scope">
                <span v-if="red">{{scope.row.dw}}</span>
                <el-input v-else size="mini" :disabled="scope.row.fphxz != '0'" v-model="scope.row.dw"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="数量" min-width="120" align="center">
              <template v-slot="scope">
                <span v-if="red">{{scope.row.spsl}}</span>
                <el-input v-else size="mini" :disabled="scope.row.fphxz != '0'" @change="itemCompute(scope.row, 1)" v-model="scope.row.spsl"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="hsbz == '0'?'单价(不含税)':'单价(含税)'" min-width="110" align="center">
              <template v-slot="scope">
                <span v-if="red">{{scope.row.dj}}</span>
                <el-input v-else size="mini" :disabled="this.temp.zsfs == '2' || scope.row.fphxz != '0'" @change="itemCompute(scope.row, 2)" v-model="scope.row.dj"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="hsbz == '0'?'金额(不含税)':'金额(含税)'" min-width="120" align="center">
              <template v-slot="scope">
                <span v-if="red">{{scope.row.je}}</span>
                <el-input v-else size="mini" :disabled="this.temp.zsfs == '2' || scope.row.fphxz != '0'" @change="itemCompute(scope.row, 3)" v-model="scope.row.je"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="税率" min-width="120" align="center">
              <template v-slot="scope">
                <span v-if="red">{{scope.row.sl}}</span>
                <span v-else-if="scope.row.lslbs == '1'">免税</span>
                <span v-else-if="scope.row.lslbs == '2'">不征税</span>
                <span v-else-if="scope.row.lslbs == '3'">{{scope.row.sl}}</span>
                <el-select v-else size="mini" :disabled="scope.row.fphxz != '0'" @change="itemCompute(scope.row, 3)" v-model="scope.row.sl" placeholder="税率">
                  <el-option
                    v-for="item in sls"
                    :key="item.name"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="税额" min-width="120" align="center"><template v-slot="scope">
                <el-input size="mini" disabled v-model="scope.row.se"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :xs="6" :sm="6" :lg="6" class="common_item"><p style="letter-spacing:30px;text-align:center;margin-left:23px">合计</p></el-col>
        <el-col :xs="6" :sm="6" :lg="6" class="common_item"><span>{{radio1}}</span></el-col>
        <el-col :xs="6" :sm="6" :lg="6" class="common_item"><p style="letter-spacing:5px;margin-left:12px">金额：<span style="letter-spacing:1px">{{temp.hjje}}</span></p></el-col>
        <el-col :xs="6" :sm="6" :lg="6" class="common_item"><p style="letter-spacing:5px;margin-left:12px">税额：<span style="letter-spacing:1px">{{temp.hjse}}</span></p></el-col>
        <el-col :xs="6" :sm="6" :lg="6" class="common_item"><p style="letter-spacing:10px;text-align:center;margin-left:20px;">价税合计(小写)</p></el-col>
        <el-col :xs="6" :sm="6" :lg="6" class="common_item"><span style="line-height: 44px;text-indent: 10px;letter-spacing:1px;margin-left:10px">{{temp.jshj}}</span></el-col>
        <el-col :xs="12" :sm="12" :lg="12" class="common_item"><p style="letter-spacing:2px;margin-left:12px;">(大写) <span>{{chinese}}</span></p></el-col>
        <el-col :xs="1" :sm="1" :lg="1">
          <div class="grid-content height_font">
            <p  v-if="temp.tspz != '02'">销货单位</p>
            <p v-else>购货单位</p>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="12">
          <el-form :label-position="labelPosition" label-width="100px" :model="temp" size="mini">
            <el-form-item label="名   称:">
              <span v-if="red">{{downCorp.xhdwmc}}</span>
              <corp v-else v-model:name="downCorp.xhdwmc" @success="corpSuccess"></corp>
            </el-form-item>
            <el-form-item label="纳税人识别号:">
              <span v-if="red">{{downCorp.xhdwsbh}}</span>
              <el-input v-else v-model="downCorp.xhdwsbh"></el-input>
            </el-form-item>
            <el-form-item label="地址、电话:">
              <el-input v-model="downCorp.xhdwdzdh"></el-input>
            </el-form-item>
            <el-form-item label="开户行及账号:">
              <el-input v-model="downCorp.xhdwyhzh"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :xs="1" :sm="1" :lg="1">
          <div class="grid-content height_font"><p>备  注</p></div>
        </el-col>
        <el-col style="padding:10px" :xs="10" :sm="10" :lg="10" class="text_box">
          <el-input style="margin-bottom:10px" v-if="fs == '2'" placeholder="请输入红冲信息表编号" v-model="temp.tzdbh" size="mini"></el-input>
          <el-input type="textarea" placeholder="请输入内容" v-model="temp.bz" maxlength="100" show-word-limit size="mini"></el-input>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form :inline="true" label-width="100px" :model="temp" size="mini">
            <el-form-item label="收款人：" style="margin-right:68px"><el-input v-model="temp.skr"></el-input></el-form-item>
            <el-form-item label="复核人：:" style="margin-right:76px"><el-input v-model="temp.fhr"></el-input></el-form-item>
            <el-form-item label="开票人：:"><el-input v-model="temp.kpr"></el-input></el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
    <!-- 差额设置弹框 -->
  <el-dialog v-model="dialogFormVisible" width="30%" title="差额设置">
    <el-form size="mini" label-position="right" label-width="100px">
      <el-form-item label="含税销售额">
        <el-input v-model="cezs.total"></el-input>
      </el-form-item>
      <el-form-item label="扣除额">
        <el-input v-model="cezs.kc"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" type="primary" @click="ceszConfirm()">确定 </el-button>
      </span>
    </template>
  </el-dialog>
  
    <!-- 添加折扣弹框 -->
  <el-dialog v-model="dialogFormVisibleZk" width="30%" title="添加折扣">
    <el-form size="mini" label-position="right" label-width="100px">
      <el-form-item label="商品原金额">
        <el-input disabled v-model="tempZk.oldAmont"></el-input>
      </el-form-item>
      <el-form-item label="折扣率（%）">
        <el-input @change="changeZkl" v-model="tempZk.zkl"></el-input>
      </el-form-item>
      <el-form-item label="折扣金额">
        <el-input disabled v-model="tempZk.amount"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" type="primary" @click="zkConfirm()">确定 </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { notOpenInvoice } from "@/api/apply";
import { openInvoice } from "@/api/open";
import { saveBig } from "@/utils/index"
import corp from "@/components/corp";
import corpghdw from "@/components/corpghdw";
import goods from '@/components/goods.vue';
import redUpload from "./components/red_upload";
import redHand from "./components/red_hand";
import redHandFs from "./components/red_hand_fs";
export default {
  name: 'invoicing',
  watch: {
    $route() {
      if(this.$route.path != "/invoiceManage/invoicing"){
        return
      }
      this.getParam()
    },
  },
  components: {
    corp,
    corpghdw,
    goods,
    redUpload,
    redHand,
    redHandFs,
  },
  data() {
    return {
        //页面显示发票代码号码
        fpdm: "",
        fphm: "",
        loading: false,
        //负数冲红发票
        red: false,//如果 使用的 获取的info 变为true 屏蔽部分地方的 改动
        fs: '0',//负数红冲
        //添加折扣
        dialogFormVisibleZk: false,
        tempZk: {
          oldAmont: 0,
          zkl: 0,
          amount: 0,
        },
        multipleTable: [],//选中元素
        zkStatus: false,
        //差额征税
        cezs: {
          total: 0,
          kc: 0,
        },
        dialogFormVisible: false,
        labelPosition: 'right',
        chinese: '',
        temp: {
          comId: this.$store.getters['user/comInfo'].id*1,
          fplxdm: this.$store.getters['user/comInfo'].fplxdm.split(',')[0],
          xfbz: "JK",
          kplx: '0',//开票类型  是	0：正数票开具1：负数票开具
          tspz: "00",// “00”不是“01”农产品销售“02”农产品收购“06”抵扣通行费“07”其它通行费“08”成品油销售
          zsfs: "0",// 征税方式0：普通征税1：减按计征2：差额征税

        },
        hsbz: "1",//含税标志 0不含税 1含税
        downCorp: {},
        upCorp: {},
        options: [
          {
            value: '0',
            label: '普通征税',
          },
          {
            value: '1',
            label: '减按征收',
          },
          {
            value: '2',
            label: '差额征收',
          },
        ],
        sls: [{
          "name": "0",
          "value": "0",

        },{
          "name": "0.01",
          "value": "0.01",

        },{
          "name": "0.015",
          "value": "0.015",

        },{
          "name": "0.02",
          "value": "0.02",

        },{
          "name": "0.03",
          "value": "0.03",

        },{
          "name": "0.05",
          "value": "0.05",

        },{
          "name": "0.06",
          "value": "0.06",

        },{
          "name": "0.09",
          "value": "0.09",

        },{
          "name": "0.10",
          "value": "0.10",

        },{
          "name": "0.11",
          "value": "0.11",

        },{
          "name": "0.13",
          "value": "0.13",

        },{
          "name": "0.16",
          "value": "0.16",

        },{
          "name": "0.17",
          "value": "0.17",

        },],
        value: '',
        items:[{
          "index": 1,
          "fphxz": "0",
          "hsbz": "1",
          "spmc": "",
					"ggxh":"",					
					"dw":"",
					"spsl":"",
					"dj":'',
					"je":'',
          "sl":"",
					"se":"",
          "spbm": "",
        }],
        checkedDetail:[],
        dialogVisible:false,
    }
  },
  created () {
    this.getParam()
    this.initInvoiceNumber()
  },
  methods:{
    //加在开票号码
    initInvoiceNumber(){
      this.fs = "0"
      if(!this.temp.fplxdm){
        return
      }
      notOpenInvoice({comId: this.temp.comId, fplxdm: this.temp.fplxdm}).then(res=>{
        if(res.data.msg == "success"){
          this.fpdm = res.data.data.fpdm
          this.fphm = res.data.data.fphm
        }else{
          this.fpdm = ""
          this.fphm = ""
        }
      })
    },
    getParam(){
      let objstr = this.$route.params.info
      if(objstr){
        let obj = JSON.parse(objstr)
        this.redInfo(obj, 'copy')
      }
    },
    clear(){
      this.temp = {
        comId: this.$store.getters['user/comInfo'].id*1,
        fplxdm: this.$store.getters['user/comInfo'].fplxdm.split(',')[0],
        xfbz: "JK",
        kplx: '0',//开票类型  是	0：正数票开具1：负数票开具
        tspz: "00",// “00”不是“01”农产品销售“02”农产品收购“06”抵扣通行费“07”其它通行费“08”成品油销售
        zsfs: "0",// 征税方式0：普通征税1：减按计征2：差额征税
      }
      this.fs = "0"
      this.items = [{
        "index": 1,
        "fphxz": "0",
        "hsbz": this.hsbz,
        "spmc": "",
        "ggxh":"",					
        "dw":"",
        "spsl":"",
        "dj":'',
        "je":'',
        "sl":"",
        "se":"",
        "spbm": "",
      }]
      // this.downCorp = {}
      this.upCorp = {}
      this.red = false
    },
    handleSelectionChange(val) {
      this.multipleTable = val
    },
    //导入清单
    qdImportSuccess(data){
      this.$refs.goods.getList()
      if(data && data.length != 0){
        // data.map(v=>{
        //   this.items.push(v)
        // })
        this.items = data
        this.changeHsbz()
      }
    },
    //负数冲红发票
    redInfo(info, form){
      console.log("info",info)
      if(form == "copy"){
        this.temp = info
      }else{
        let fplxdm = this.temp.fplxdm
        this.temp = info
        this.temp.fplxdm = fplxdm
      }
      
      this.temp.comId = this.$store.getters['user/comInfo'].id*1
      this.temp.xfbz = "JK"
      if(form == "copy"){//复制
        this.temp.id = 0
        this.temp.tspz = info.tspz
        this.temp.kplx = info.kplx
        this.temp.fplxdm = info.fplxdm
        this.temp.tspz = "00"
        info.item.map((v, i)=>{
          v.id = 0
          v.zxbm = ""
          v.index = i + 1
        })
        this.items = info.item
        // this.red = true
      }else{//冲红发票
        this.temp.tspz = "00"
        this.temp.kplx = "1"
        // this.temp.fplxdm = "004"
        this.temp.sfwbfhc = "1" // 如果为 0 或者 空 代表为部分红冲进行原票校验，为 1 则不进行原票校验
        info.item.map(v=>{
          v.id = 0
          v.itemId = 1
        })
        this.items = info.item
        this.red = true
        // this.cezs.kc = info.kce//差额征税的扣除额
      }

      this.upCorp.ghdwsbh = info.ghdwsbh
      this.upCorp.ghdwmc = info.ghdwmc
      this.upCorp.ghdwdzdh = info.ghdwdzdh
      this.upCorp.ghdwyhzh = info.ghdwyhzh

      this.downCorp.xhdwsbh = info.xhdwsbh
      this.downCorp.xhdwmc = info.xhdwmc
      this.downCorp.xhdwdzdh = info.xhdwdzdh
      this.downCorp.xhdwyhzh = info.xhdwyhzh
      this.chinese = saveBig(info.jshj)
      
      
      this.hsbz = info.item[0].hsbz
      
    },
    //切换开票类型
    changeFs(){
      if(this.fs != '0'){
        this.temp.kplx = '1'
      }else{
        this.temp.kplx = '0'
      }
      //是否为部分红冲 如果为 0 或者 空 代表为部分红冲进行原票校验，为 1 则不进行原票校验
      if(this.fs == '2'){
        this.temp.sfwbfhc = "1"
      }else{
        this.temp.sfwbfhc = ""
      }
    },
    //删除item
    delItem(){
      if(this.multipleTable.length == this.items.length){
        this.$qzfMessage("请至少保留一行",1)
        return
      }
      //先判断是否折扣商品
      let bzkh = this.multipleTable.filter(v=>{return v.fphxz == "2"})
      let status = false
      bzkh.map(v=>{
        let s = this.multipleTable.filter(z=>{return v.index == z.zkIndex})
        if(s.length == 0){
          status = true
        }
      })
      if(status){
        this.$qzfMessage("请先删除折扣行", 2)
        return
      }
      //验证完成可以删除
      let zkArr = []
      console.log(this.items);
      console.log(this.multipleTable);
      let items = this.items.filter(v=>{
        let x = true
        for(let i=0;i<this.multipleTable.length;i++){
          if((this.multipleTable[i].index && this.multipleTable[i].index == v.index) || (this.multipleTable[i].zkIndex && this.multipleTable[i].zkIndex == v.zkIndex)){
            if(this.multipleTable[i].zkIndex){
              zkArr.push(this.multipleTable[i].zkIndex)
            }
            x = false
            break
          }
        }
        return x
      })
      //已删除的折扣行 修改被折扣行状态
      items.map(v=>{
        if(zkArr.includes(v.index)){
          v.fphxz = "0"
        }
      })
      this.items = items
    },
    //查询是否在折扣中
    isZkIn(){
      let status = false
      this.items.map(v=>{
        if(v.fphxz != "0"){
          status = true
        }
      })
      this.zkStatus = status
    },
    //确认添加折扣
    zkConfirm(){
      console.log(this.tempZk)
      this.multipleTable.map(v=>{
        for(let i=0;i<this.items.length;i++){
          if(this.items[i].index == v.index){//此节点需要新增折扣
            console.log(v.index,i)
            //先把主元素 fphxz 改了 默认0 1折扣行  2被折扣行
            this.items[i].fphxz = "2"
            //插入一个折扣
            let zk = Object.assign({}, this.items[i])
            zk.fphxz = "1"
            zk.spsl = ""
            zk.dj = ""
            zk.index = 0
            zk.zkIndex = v.index
            zk.je = String((-zk.je * this.tempZk.zkl / 100).toFixed(2))
            zk.se = String((-zk.se * this.tempZk.zkl / 100).toFixed(2))
            this.items.splice(i + 1, 0, zk)
            break
          }
        }
      })
      this.dialogFormVisibleZk = false
      this.isZkIn()
    },
    //添加折扣
    addZk(){
      if(this.multipleTable.length == 0){
        this.$qzfMessage("请选择折扣商品", 1)
        return
      }
      //查询折扣商品是否都有金额
      let status = false
      this.multipleTable.map(v=>{
        if(v.je == 0 || v.spmc == ""){
          status = true
        }
      })
      if(status){
        this.$qzfMessage("请补全商品信息再进行折扣", 1)
        return
      }
      this.multipleTable.map(v=>{
        if(v.fphxz != "0"){
          status = true
        }
      })
      if(status){
        this.$qzfMessage("折扣商品不可折扣", 2)
        return
      }
      //过滤完成统计金额
      let amount = 0
      this.multipleTable.map(v=>{
        amount = (amount*1 + v.je*1).toFixed(2)
      })
      this.tempZk.oldAmont = amount
      this.tempZk.amount = 0
      this.tempZk.zkl = 0
      this.dialogFormVisibleZk = true
    },
    changeZkl(){
      this.tempZk.amount = (this.tempZk.oldAmont * this.tempZk.zkl / 100).toFixed(2)
    },
    //差额征税设置确认
    ceszConfirm(){
      if(this.cezs.total == 0){
        this.$qzfMessage("请填写信息", 1)
        return
      }
      let total = String((this.cezs.total*1 - this.cezs.kc*1).toFixed(2))
      let bhsje = String((total/(1 + this.items[0].sl*1)).toFixed(2))
      this.items[0].se = String((total * 1 - bhsje * 1).toFixed(2))
      this.items[0].je = String((this.cezs.total - this.items[0].se).toFixed(2))
      this.dialogFormVisible = false
      this.tempCompute()
    },
    //更改含税标志
    changeHsbz(){
      this.items.map(v=>{
        this.itemCompute(v, 1)
        v.hsbz = this.hsbz
      })
    },
    //item计算 from1 数量 2单价 3金额
    itemCompute(row, from){
      //差额征税的另一种计算方式
      if(this.temp.zsfs == '2'){
        let bhsje = ((this.cezs.total*1 - this.cezs.kc*1)/(1 + row.sl*1)).toFixed(2)
        row.se = ((this.cezs.total*1 - this.cezs.kc*1) * 1 - bhsje * 1).toFixed(2)
        row.je = (this.cezs.total*1 - row.se)
        if(row.spsl){
          row.dj = (row.je / row.spsl).toFixed(10)
        }
        this.tempCompute()
        return
      }
      if(this.hsbz == "0"){//不含税
        if(from == 1 || from == 2){
          row.je = (row.spsl * row.dj).toFixed(2)?(row.spsl * row.dj).toFixed(2):0
          row.se = (row.je * row.sl).toFixed(2)?(row.je * row.sl).toFixed(2):0
        }else if(from == 3){
          if(row.spsl * 1){
            row.dj = (row.je / row.spsl).toFixed(10)?(row.je / row.spsl).toFixed(10):0
          }else if(row.dj * 1){
            row.spsl = (row.je / row.dj).toFixed(10)?(row.je / row.dj).toFixed(10):0
          }
          row.se = (row.je * row.sl).toFixed(2)?(row.je * row.sl).toFixed(2):0
        }
      }else{
        if(from == 1 || from == 2){
          row.je = (row.spsl * row.dj).toFixed(2)?(row.spsl * row.dj).toFixed(2):0
          let bhsje = (row.je/(1 + row.sl*1)).toFixed(2)?(row.je/(1 + row.sl*1)).toFixed(2):0
          row.se = (row.je * 1 - bhsje * 1).toFixed(2)?(row.je * 1 - bhsje * 1).toFixed(2):0
        }else if(from == 3){
          if(row.spsl * 1){
            row.dj = (row.je / row.spsl).toFixed(10)?(row.je / row.spsl).toFixed(10):0
          }else if(row.dj * 1){
            row.spsl = (row.je / row.dj).toFixed(10)?(row.je / row.dj).toFixed(10):0
          }
          let bhsje = (row.je/(1 + row.sl*1)).toFixed(2)?(row.je/(1 + row.sl*1)).toFixed(2):0
          row.se = (row.je * 1 - bhsje * 1).toFixed(2)?(row.je * 1 - bhsje * 1).toFixed(2):0
        }
      }
      this.tempCompute()
    },
    //计算合计
    tempCompute(){
      let amount = 0
      let tax = 0
      let total = 0
      
      if(this.hsbz == "0"){//不含税
        this.items.map(v=>{
          amount = (amount*1 + v.je*1).toFixed(2)
          tax = (tax*1 + v.se*1).toFixed(2)
        })
        total = (amount*1 + tax*1).toFixed(2)
      }else{
        this.items.map(v=>{
          total = (total*1 + v.je*1).toFixed(2)
          tax = (tax*1 + v.se*1).toFixed(2)
        })
        amount = (total*1 - tax*1).toFixed(2)
      }
      this.chinese = saveBig(total)
      this.temp.hjje = String(amount)
      this.temp.hjse = String(tax)
      this.temp.jshj = String(total)
    },
    //修改商品
    goodSuccess(e,row){
      row.ggxh = e.spec
      row.dw = e.unit
      row.dj = e.price
      row.spbm = e.short_code

      row.yhzcbs = e.yh_status
      if(row.yhzcbs == 1){
        row.zzstsgl = e.yh_text
      }
      row.lslbs = e.mslx
      row.sl = e.rate
      if(this.temp.zsfs == '2'){
        this.dialogFormVisible = true
      }
    },
    //保存发票
    saveInvoice(type){
      if(type == 4){
        this.$confirm("确定保存为模板", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveInvoices(type)
        })
      }else{
        let text = "确认开具" + this.$fplx(this.temp.fplxdm)
        this.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveInvoices(type)
        })
      }
      
    },
    saveInvoices(type){
      if(this.temp.tspz == "02"){//收购发票
        this.temp.xhdwsbh = this.upCorp.ghdwsbh
        this.temp.xhdwmc = this.upCorp.ghdwmc
        this.temp.xhdwdzdh = this.upCorp.ghdwdzdh
        this.temp.xhdwyhzh = this.upCorp.ghdwyhzh
        this.temp.ghdwsbh = this.downCorp.xhdwsbh
        this.temp.ghdwmc = this.downCorp.xhdwmc
        this.temp.ghdwdzdh = this.downCorp.xhdwdzdh
        this.temp.ghdwyhzh = this.downCorp.xhdwyhzh

      }else{
        this.temp.xhdwsbh = this.downCorp.xhdwsbh
        this.temp.xhdwmc = this.downCorp.xhdwmc
        this.temp.xhdwdzdh = this.downCorp.xhdwdzdh
        this.temp.xhdwyhzh = this.downCorp.xhdwyhzh
        this.temp.ghdwsbh = this.upCorp.ghdwsbh
        this.temp.ghdwmc = this.upCorp.ghdwmc
        this.temp.ghdwdzdh = this.upCorp.ghdwdzdh
        this.temp.ghdwyhzh = this.upCorp.ghdwyhzh
      }
      //验证
      console.log(this.temp)
      // if(!this.temp.ghdwsbh){
      //   this.$qzfMessage("请填写购货单位信息", 2)
      //   return
      // }
      if(!this.temp.xhdwsbh){
        this.$qzfMessage("请填写销货单位信息", 2)
        return
      }
      if(!this.temp.fplxdm){
        this.$qzfMessage("请选择发票类型代码", 2)
        return
      }
      if(!this.temp.hjje){
        this.$qzfMessage("合计金额不可为0", 2)
        return
      }
      

      let item = []
      //处理item
      let status = false
      this.items.map(v=>{
        if(!v.itemId || !v.je){ // || !v.sl 
          status = true
        }
      })
      if(status){
        this.$qzfMessage("请补全商品信息，删除多余行次", 2)
        return
      }
      item = this.items
      item.map(v=>{
        v.je = String(v.je)
        v.se = String(v.se)
        v.sl = String(v.sl)
      })
      this.temp.item = item
      item.length > 8?this.temp.qdbz = "1":this.temp.qdbz = "0"//清单标识
      //差额征税扣除额
      if(this.temp.zsfs == "2"){
        this.temp.kce = this.cezs.kc*1 != 0?String(this.cezs.kc):""
      }
      this.temp.status = type//4保存为模板
      console.log(this.temp)
      this.loading = true
      openInvoice(this.temp).then(res=>{
        this.loading = false
        if(res.data.msg == "success" && type != 4){
          this.$qzfMessage("开票成功，请前往开票列表页面查看，请勿重复开票")
          //跳转页面
          this.$router.push({name: "invoiceQuery"});
          this.$store.dispatch("tagsView/delCachedViewByName", 'invoiceQuery') // 清除缓存
          this.$store.dispatch("tagsView/delCachedViewByName", 'queryPrint') // 清除缓存
          this.$store.dispatch("tagsView/delViewByName", 'invoicing') // 关闭本页面
        }else if(res.data.msg == "success" && type == 4){
          this.$qzfMessage("保存模板成功，请前往开票列表页面选着模板查看")
          //跳转页面
          this.$router.push({name: "invoiceQuery"});
          this.$store.dispatch("tagsView/delCachedViewByName", 'invoiceQuery') // 清除缓存
          this.$store.dispatch("tagsView/delCachedViewByName", 'queryPrint') // 清除缓存
          this.$store.dispatch("tagsView/delViewByName", 'invoicing') // 关闭本页面
        }
      })
      
    },
    //征税方式改变
    zsfsChange(){
      if(this.temp.zsfs != "0"){
        this.temp.tspz = '00'
      }
      //差额征税 只能添加一个item 并且 必须是含税
      if(this.temp.zsfs == "2"){
        this.hsbz = "0"
        this.items = [{
          "fphxz": "0",
          "hsbz": this.hsbz,
        }]
        this.hsbz = "0"
      }else if(this.temp.zsfs == "1"){
        this.hsbz = "1"
        this.items = [{
          "fphxz": "0",
          "hsbz": this.hsbz,
        }]
      }
    },
    //购货单位回调
    corpghdwSuccess(e){
      console.log(e)
      this.corpghdw = e
      this.completionCorp()
    },
    //销货单位回调
    corpSuccess(e){
      console.log(e)
      this.corp = e
      this.completionCorp()
    },
    //补全单位信息
    completionCorp(){
      if(this.corp){
        this.downCorp.xhdwsbh = this.corp.tax_no
        this.downCorp.xhdwmc = this.corp.name
        this.downCorp.xhdwdzdh = this.corp.address + this.corp.tel
        this.downCorp.xhdwyhzh = this.corp.khhmc + this.corp.khhzh

        this.temp.skr = this.corp.skr
        this.temp.fhr = this.corp.fkr
        this.temp.kpr = this.corp.kpr
      }
      if(this.corpghdw && this.corpghdw.tax_no){
        this.upCorp.ghdwsbh = this.corpghdw.tax_no
        this.upCorp.ghdwmc = this.corpghdw.name
        this.upCorp.ghdwdzdh = this.corpghdw.address + this.corpghdw.tel
        this.upCorp.ghdwyhzh = this.corpghdw.khhmc + this.corpghdw.khhzh
      }else{
        this.upCorp.ghdwsbh = ""
        this.upCorp.ghdwmc = ""
        this.upCorp.ghdwdzdh = ""
        this.upCorp.ghdwyhzh = ""
      }
      
    },
    init(){
      
    },
    addRow(){
      this.items.push({
          "fphxz": "0",//发票行性质0 正常行1、折扣行2、 被折扣行3、清单开负数（只针对于ukey）
          "hsbz": this.hsbz,
          "index": this.items[this.items.length - 1].index + 1,//编号 用于折扣商品
					"spmc": "",
					"ggxh":"",					
					"dw":"",
					"spsl":"",
					"dj":'',
					"je":'',
          "sl":"",
					"se":"",
          "spbm": "",
				});
    },
    deleteRow(){
      // this.items.splice(this.$refs.multipleTable.store.states.selection,1)
    }
  }
}
</script>

<style>
.text_box .el-textarea{
  height: 100%;
}
.text_box .el-textarea__inner{
  min-height: 80px !important;
}
</style>
<style lang="scss" scoped>
.big_box2 {
  width: 98%;
  padding:15px 64px 40px 64px;
  background: #fff;
  box-shadow: 0 2px 10px #ddd;
  margin: 15px auto;
  // height: 890px;
  position: relative;
  border:1px solid #ddd;
  .shuoming{
    color:red;
    position: absolute;
    top: 18px;
    left:66px;
  }
  .arrow_btn {
    width: 20px;
    height: 60px;
    text-align: center;
    .two_btn {
      font-size: 20px;
      color: #f15a24;
      line-height: 60px;
      background: #eee;
    }
    .arrow_left {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .arrow_right {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.content {
  width: 100%;
  margin: 0 auto;
  border: 1px solid #008000;
  margin-top: 10px;
  border-right: none;
  // height: 684px;
}
.row_box2 {
  width: 100%;
  // height: 200px;
}
.grid-content {
  position: relative;
  min-height: 38px;
  font-size: 15px;
  color: #666;
  line-height: 38px;
  text-align: center;
}
.height_font {
  // writing-mode: vertical-lr;
  // padding: 0 15px;
  width: 100%;
  height: 156px;
  margin: 0 auto;
  text-align: center;
  background-color: whitesmoke;
  p {
    width: 20px;
    margin: 0 auto;
    height: 100%;
    line-height: 32px;
    padding-top: 14px;
  }
}
p{
  font-size: 14px;
}
.content{
  .el-row {
    width: 100%;
    // border:1px solid #eee;
  }
  .el-col {
    border-right: 1px solid #008000;
    border-bottom: 1px solid #008000;
  }
  .bg-purple {
    text-align: center;
    // position: relative;
  }
  .special .el-col {
    border-right: 1px solid #d56400;
  }
}
.list_info {
  line-height: 24px;
  &.red li {
    border-bottom: 1px solid #d56400 !important;
  }
  li {
    position: relative;
    line-height: 38px;
    height: 38px;
    font-size: 13px;
    color: #333;

    &:last-child {
      border-bottom: none;
    }
    input {
      width: 100%;
      margin: 0 auto;
      height: 36px;
      line-height: 36px;
      font-size: 13px;
      color: #333;
      background: none;
      border: none;
      padding: 0 5px;
    }
  }
}
.bottom_ad{
  float: left;
}
.name_box{
  text-align: center;
  font-size: 24px;
  h2{
    margin:0;
    font-family: cursive;
    letter-spacing: 4px;
    color:#008000;
    border-bottom:4px double green;
    display: inline-block;
  }
}
.right{
  position: absolute;
  right: 50px;
  top: 120px;
}
.left{
  position: relative;
  top: 20px;
  left: 10px;
  width: 860px;
}
.el-form-item--mini.el-form-item{
  margin-bottom: 5px;
}
.el-form{
  margin:10px 12px;
}
.el-textarea{
  // width: 94%;
  // margin: 10px 10px 10px 10px;
}

.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.home{
  margin-bottom: -6px;
  margin-top: 11px;
  padding: 0 !important;
}
.top{
  padding: 15px 20px 0 12px;
  p{
    float: left;
    font-size: 13px;
    color: #333;
    padding: 0;
    margin: 0;
    line-height: 28px;
  }
}
.common_item{
  height: 40px;
  line-height: 40px;
  p{
    font-size: 13px;
    color: #333;
    margin: 0;
  }
}
</style>